import { useMemo } from 'react';
import { useGetEditOrActual } from '../../CampaignSettings/selectors/useGetEditOrActual';

export const useBranchesSelector = () => {
  const state = useGetEditOrActual();

  return useMemo(() => Object.keys(state.branches).map(k => state.branches[k]), [state.branches]);
};
